import { AxiosResponse } from "axios";
import { api } from "../api";
import { ManipulativeAlternativesCoverage } from "./manipulative-alternatives.types";

export const getManipulativeAlternativesCoverage =
  async (): Promise<ManipulativeAlternativesCoverage | null> => {
    try {
      const response: AxiosResponse<ManipulativeAlternativesCoverage> =
        await api.get("/manipulative-alternatives/coverage");
      return response.status === 200 ? response.data : null;
    } catch (error: any) {
      console.error(error);
      // El aviso es informativo: si no se puede leer, el formulario sigue
      // funcionando sin él en lugar de bloquear el guardado.
      return null;
    }
  };
